import { render, staticRenderFns } from "./SettingsStatuses.vue?vue&type=template&id=2be6f71b&"
import script from "./SettingsStatuses.vue?vue&type=script&lang=js&"
export * from "./SettingsStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports